import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  spoilerTitleClassName: {
    fontSize: '14px',
    fontWeight: 400,
    marginLeft: '0px'
  }
})

export default useStyles
